<template>
  <div class="tree-container">
    <div @click="nodeBodyClicked"
         class="node pl-3 pr-2 py-2" :class="nodeClass">
      <div class="d-flex flex-justify-content-start">
        <!-- carrot symbol -->
        <div v-if="model.children && model.children.length"
             class="toggle-spacer"
             @click.stop="nodeHandlerClicked">
          <font-awesome-icon icon="angle-right" class="toggle" :class="{expanded: model.state.expanded}" />
        </div>
        <div v-else-if="indentNodeLabel" class="toggle-spacer" />
        <div v-else class="label-spacer" />
        <div class="w-100">
          <slot :node="model">
            <div class="d-flex justify-content-between w-100">
              <span class="label" :class="model.labelStyle">
                {{ model.label }}
              </span>
              <span v-if="model.subLabel && typeof model.subLabel === 'string'" class="sub-label">
                {{ model.subLabel }}
              </span>
            </div>
          </slot>
        </div>
      </div>
    </div>
    <transition name="fade">
      <ul v-show="model.siblings && model.siblings.length && model.state.expanded"
          class="tree-sibling">
        <li v-for="child of model.siblings" :key="child.id">
          <tree-node :model="child"
                     :simple="simple"
                     @nodeSelected="$emit('nodeSelected', $event)"
                     @nodeExpanded="$emit('nodeExpanded', $event)"
                     @nodeUpdated="$emit('nodeUpdated', $event)">
            <template v-if="!simple" slot-scope="{ node }">
              <slot :node="node" />
            </template>
          </tree-node>
        </li>
      </ul>
    </transition>
    <transition name="fade">
      <ul v-show="model.children && model.children.length && model.state.expanded"
          class="sub-tree">
        <li v-for="child of model.children" :key="child.id">
          <tree-node :model="child"
                     :simple="simple"
                     @nodeSelected="$emit('nodeSelected', $event)"
                     @nodeExpanded="$emit('nodeExpanded', $event)"
                     @nodeUpdated="$emit('nodeUpdated', $event)">
            <template v-if="!simple" slot-scope="{ node }">
              <slot :node="node" />
            </template>
          </tree-node>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>

import { getUsageType } from '@/utils'

export default {
  name: 'TreeNode',
  props: {
    model: {
      type: Object,
      default: () => null
    },
    simple: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    nodeBodyClicked () {
      const node = this.model
      node.setSelected()
      this.$emit('nodeSelected', node)
    },
    nodeHandlerClicked () {
      const node = this.model
      if (node.state && node.props && node.props.expandable && !node.disabled) {
        node.state.expanded = !node.state.expanded
        this.$emit('nodeExpanded', node)
      }
    }
  },
  created () {
    if (this.model.listenerCount('updated') === 0) {
      this.model.on('updated', (tree) => {
        this.$emit('nodeUpdated', tree)
      })
    }
  },
  computed: {
    indentNodeLabel() {
      //console.log('indentNodeLabel')
      const p = this.model.parent

      if (getUsageType() === 1) {
      //console.log('getUsageType() === 1')
        if (!p) {
          return false
        }

        return p.children.some(e => e.children && e.children.length)
      }
      else if (getUsageType() === 2) {
        //console.log('getUsageType() === 2')
        //console.log('this.depth ' + this.model.depth)
        return false
      }

    },
    nodeClass () {
      return {
        'node--selected': this.model.state && this.model.state.selected,
        'node--disabled': this.model.disabled
      }
    }
  }
}
</script>

<style lang="scss">
  $selectedNodeBg: darken(GhostWhite, 2%);
  $hoveredNodeBg: rgba($selectedNodeBg, 0.4);
  .tree-container {
    .sub-tree {
      list-style: none;
      padding-left: 2rem;
    }
    .tree-sibling {
      list-style: none;
      padding-left: 0.01rem;
    }
    .node {
      cursor: pointer;
      border-radius: 5px;
      &--selected {
        background-color: $selectedNodeBg;
      }
      &:hover:not(.node--selected) {
        background-color: $hoveredNodeBg;
      }
      &--disabled {
        filter: grayscale(100%) blur(1px);
        background-color: lighten(lightgray, 15%) !important;
        &.node--selected,
        & .btn {
          cursor: not-allowed;
        }
      }
      .toggle-spacer {
        width: 1.25rem;
      }
      .label-spacer {
        width: 1.25rem;
      }
      .label {
        font-weight: bold;
        user-select: none;
      }
      .sub-label {
        font-size: smaller;
        font-weight: bold;
        user-select: none;
      }
      .toggle {
        transition: transform .3s ease-out;
        &.expanded {
          transform: rotate(90deg);
          transition: transform .3s ease-out;
        }
      }
    }
  }
</style>
